import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import MainLayout from "./layout/MainLayout";
import Associate from "./pages/Associate";
import Booze from "./pages/Booze";
import BulletFactory from "./pages/BulletFactory";
import BulletHistory from "./pages/BulletHistory";
import Business from "./pages/Business";
import CashHistory from "./pages/CashHistory";
import CrateOpening from "./pages/CrateOpening";
import CreditHistory from "./pages/CreditHistory";
import Crime from "./pages/Crime";
import Exchange from "./pages/Exchange";
import Family from "./pages/Family";
import FamilyCreatePage from "./pages/FamilyCreatePage";
import FamilyLeaderBoard from "./pages/FamilyLeaderBoard";
import Garage from "./pages/Garage";
import HelperBot from "./pages/HelperBot";
import InJailPage from "./pages/InJail";
import Jail from "./pages/Jail";
import KillSkill from "./pages/KillSkill";
import BuyPage from "./pages/Landing";
import Map from "./pages/Map";
import MapGame from "./pages/MapGame";
import MarketPage from "./pages/Market";
import MarketingDao from "./pages/MarketingDao";
import Narcotics from "./pages/Narcotics";
import NewLanding from "./pages/NewLanding";
import NickCar from "./pages/NickCar";
import Profile from "./pages/Profile";
import Roulette from "./pages/Roulette";
import Slot from "./pages/Slot";
import Travel from "./pages/Travel";
import Vault from "./pages/Vault";

import "./app/axiosSetup"; // Make sure to import the interceptor setup

import { useAppDispatch } from "./app/hooks";
import { activityTracking } from "./reducers/auth.slice";
import Bank from "./pages/Bank";

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(activityTracking());
  }, [location, dispatch]);

  return (
    <Box>
      <MainLayout>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<NewLanding />} />
          <Route path="/buy" element={<BuyPage />} />
          <Route path="/profile" element={<NewLanding />} />
          <Route path="/profile/:profileName" element={<Profile />} />
          <Route path="/vault" element={<Vault />} />

          <Route path="/family/" element={<FamilyLeaderBoard />} />
          <Route path="/familycreate" element={<FamilyCreatePage />} />
          <Route path="/family/:familyName" element={<Family />} />

          <Route path="/crate" element={<CrateOpening />} />

          <Route path="/market" element={<MarketPage />} />
          <Route path="/market/itemList" element={<MarketPage />} />
          <Route path="/market/history" element={<MarketPage />} />
          <Route path="/market/myListings" element={<MarketPage />} />
          <Route path="/market/item/:itemId" element={<MarketPage />} />

          <Route
            path="/exchange/convert"
            element={<Exchange subpage="convert" />}
          />
          <Route path="/exchange" element={<Exchange subpage="deposit" />} />
          <Route
            path="/exchange/deposit"
            element={<Exchange subpage="deposit" />}
          />
          <Route
            path="/exchange/withdraw"
            element={<Exchange subpage="withdraw" />}
          />
          <Route
            path="/exchange/trade"
            element={<Exchange subpage="otcTrade" />}
          />
          <Route
            path="/exchange/trade-create"
            element={<Exchange subpage="otcCreate" />}
          />
          <Route path="/exchange/keys" element={<Exchange subpage="keys" />} />

          <Route path="/map" element={<Map />} />

          <Route path="/map/:city" element={<MapGame />} />

          <Route path="/dao" element={<MarketingDao />} />

          <Route path="/cash/history" element={<CashHistory />} />

          <Route path="/credit/history" element={<CreditHistory />} />

          <Route path="/roulette/:cityId" element={<Roulette />} />

          <Route path="/slotmachine/:cityId" element={<Slot />} />

          <Route path="/businesses" element={<Business />} />

          <Route path="/crimes" element={<Crime />} />

          <Route path="/jail" element={<Jail />} />

          <Route path="/travel" element={<Travel />} />

          <Route path="/nickcar" element={<NickCar />} />

          <Route path="/injail" element={<InJailPage />} />

          <Route path="/helper" element={<HelperBot />} />

          <Route path="/booze/:cityId" element={<Booze />} />

          <Route path="/narcotics/:cityId" element={<Narcotics />} />

          <Route path="/garage/:cityId" element={<Garage />} />
          <Route path="/garage" element={<Garage />} />

          <Route path="/rank" element={<Associate />} />

          <Route path="/killskill" element={<KillSkill />} />

          <Route path="/bullet/factory/:cityId" element={<BulletFactory />} />

          <Route path="/bullet/history" element={<BulletHistory />} />

          <Route path="/bank/:cityId" element={<Bank />} />
        </Routes>
      </MainLayout>
    </Box>
  );
};

export default App;
